import type {
  CatalogIntegrationAccepted,
  CatalogIntegrationJob,
} from '@united-square/catalog-contract'
import { fetchJSON, resolveApiUrl } from '@runtime/shared/api/fetchJSON'
import { createAdminApiError, createAdminAuthHeaders } from '@studio/routes/hub/admin/adminApiAuth'

export const CATALOG_INTEGRATIONS_CHANGED = 'catalog-integrations-changed'
const requestKeys = new Map<string, string>()

export async function submitQrIntegration(token: string, path: string) {
  const key = requestKeys.get(path) || crypto.randomUUID()
  requestKeys.set(path, key)
  const response = await fetch(resolveApiUrl(path), {
    method: 'POST',
    headers: { ...createAdminAuthHeaders(token), 'Idempotency-Key': key },
  })
  if (!response.ok) throw await createAdminApiError(response, path)
  const result = (await response.json()) as CatalogIntegrationAccepted
  requestKeys.delete(path)
  window.dispatchEvent(new Event(CATALOG_INTEGRATIONS_CHANGED))
  return result
}

export async function listQrIntegrations(token: string, signal?: AbortSignal) {
  const result = await fetchJSON<{
    jobs: CatalogIntegrationJob[]
    worker: { available: boolean; heartbeatAt: string | null }
  }>('/api/admin/catalog/integration-jobs/qrcodex', {
    headers: createAdminAuthHeaders(token),
    signal,
  })
  if (!result || !Array.isArray(result.jobs) || typeof result.worker?.available !== 'boolean')
    throw new Error('catalog_integration_response_invalid')
  return result
}

export function retryQrIntegration(token: string, id: string) {
  return submitQrIntegration(token, `/api/admin/catalog/integration-jobs/qrcodex/${id}/retry`)
}
